export default "__VITE_ASSET__CjXqebhz__"